import emailjs from '@emailjs/browser';

const newLeadNotify = (service, data, key) => {
    const templates = {
        residential: "template_f9ntnax",
        commercial: "template_knt0rmj"
    }
    
    if(data.commercialCustomer) {
        // send commercial email template internally
        emailjs.send(service, templates.commercial, data, key)
            .then((res) => {
                console.log('commerical sent', res)
            })
            .catch((err) => {
                console.log("it wasn't sent",err)
            })
    } else {
        // send residential email template 
        emailjs.send(service, templates.residential, data, key)
        .then((res) => {
            console.log('residential sent', res)

        })
        .catch((err) => {
            console.log("it wasn't sent",err)
        })
    }


}

export default newLeadNotify;
